// AIC 数据资产统一在个人中心的 AIC 页面管理，Vibe 项目列表默认只展示业务应用。
export const DEFAULT_PROJECT_KIND_FILTER = 'application'

function isTrue(value) {
    return value === true || value === 1 || value === '1' || value === 'true'
}

export function getVibeProjectKind(project) {
    return project?.projectKind === 'dataset' ? 'dataset' : 'application'
}

export function filterVibeProjects(projects, ownershipFilter = 'all', projectKindFilter = DEFAULT_PROJECT_KIND_FILTER) {
    let filtered = Array.isArray(projects) ? projects : []
    if (projectKindFilter !== 'all') {
        filtered = filtered.filter(project => getVibeProjectKind(project) === projectKindFilter)
    }
    if (ownershipFilter === 'owned') {
        return filtered.filter(project => isTrue(project.isOwner))
    }
    if (ownershipFilter === 'permitted') {
        return filtered.filter(project => !isTrue(project.isOwner) && isTrue(project.hasPermission))
    }
    return filtered
}
